import React, { useCallback, useEffect, useMemo } from 'react';

import { DynamicIconWrapper, Icons } from '@components/common';

import { useQueryActiveSitesData } from '@hooks/sites/useQueryActiveSitesData';

import { map } from '@store/selectors';
import { useAppDispatch, useAppSelector } from '@store/store';

import DashboardKpiMap, { IDashboardKpiProps } from './DashboardKpiMap';

import styles from './DashboardKpiMap.module.scss';

interface IDashboardKpiMapButtonProps extends Omit<IDashboardKpiProps, 'isSingleSiteSelected' | 'isMultipleSitesSelected' | 'activeSites'> {
	setIsVisibleSiteInfo: React.Dispatch<React.SetStateAction<boolean>>;
	activeCustomPolygonIds: string[];
}

const DashboardKpiMapButton = ({
	activeCustomPolygonIds,
	handleCloseSiteCard,
	handleHideSiteCard,
	isVisibleSiteInfo,
	panTo,
	setIsVisibleSiteInfo,
}: IDashboardKpiMapButtonProps) => {
	const { activeSites: _activeSites } = useQueryActiveSitesData();
	const {
		activeSiteMarkers,
		activeBoroughs,
		activeCustomPolygons,
	} = useAppSelector(map);
	const dispatch = useAppDispatch();

	const activeSites = useMemo(() => {
		if (activeSiteMarkers.length || activeBoroughs.length || activeCustomPolygons.length) {
			return _activeSites;
		}

		return [];
	}, [
		_activeSites,
		activeBoroughs.length,
		activeCustomPolygons.length,
		activeSiteMarkers.length,
	]);

	const openSiteInfo = useCallback(() => {
		setIsVisibleSiteInfo(true);
	}, [setIsVisibleSiteInfo]);

	useEffect(() => {
		setIsVisibleSiteInfo(activeSites.length > 0);
	}, [activeSites.length, dispatch, setIsVisibleSiteInfo]);

	return (
		<>
			<div
				className={styles.siteInfoIcon}
				onClick={openSiteInfo}
			>
				<DynamicIconWrapper icon={Icons.kpiIconOutline} />
			</div>
			<DashboardKpiMap
				activeCustomPolygonIds={activeCustomPolygonIds}
				activeSites={activeSites}
				handleCloseSiteCard={handleCloseSiteCard}
				handleHideSiteCard={handleHideSiteCard}
				isMultipleSitesSelected={activeSites.length > 1}
				isSingleSiteSelected={activeSites.length === 1}
				isVisibleSiteInfo={isVisibleSiteInfo}
				panTo={panTo}
			/>
		</>
	);
};

export default DashboardKpiMapButton;
